<template>
    <el-dialog :visible.sync="visible" title="配置服务器信息" width="850px" :before-close="cancel" :close-on-click-modal="false" lock-scroll>
        <div class="container-domain">
            <div class="domain-content" ref="list">
                <div class="domain-item" ref="item1" v-for="(item, key) in domainInfo">
                    <div class="domain-name">{{item.key}}合法域名</div>
                    <div class="container">
                        <el-input
                            ref="textarea"
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 15}"
                            resize="none"
                            :placeholder="`以${item.key === 'socket' ? 'wss://' : 'https://'}开头，可填写多个域名，域名间请用;分割`"
                            v-model="domainInfo[key].content"
                            :class="['textarea', {show: showIpt}]"
                            @change="iptBlur(key, item.content)"
                            @blur="iptBlur(key, item.content)"
                        />
                        <div class="temp" @click="start(key)" v-if="!item.showIpt">
                            <span v-if="!item.content" class="empty">{{`以${item.key === 'socket' ? 'wss://' : 'https://'}开头，可填写多个域名，域名间请用;分割`}}</span>
                            <template v-else>
                                <div v-for="(text, subKey) in formatCon(item.content)" :key="subKey" class="line">
                                    <span
                                        v-for="(t, index) in text"
                                        :key="index"
                                        :class="{error: validation(t, subKey, item.key)}"
                                    >{{t}}</span>
                                </div>
                            </template>
                        </div>
                        <div class="error-info">{{errorFlag[item.key] && errorFlag[item.key].size ? '该域名包含非法字符，只支持英文大小写字母、数字、“:”及“-”' : ' '}}</div>
                    </div>
                </div>
                <div class="btn">
                    <span class="btn-cancle" @click="cancel">取消</span>
                    <span class="btn-ok" @click="submit">保存并提交</span>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import dao from '@/lib/dao';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object
        },
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            errorFlag: {},
            showIpt: true,
            content: '',
            list: [],
            domainInfo: [],
            textarea: '',
            requestList: '',
            socketList: '',
            uploadFileList: '',
            downloadFileList: '',
            formatContent: ''
        }
    },
    methods: {
        formatCon(content) {
            return content.split('\n').map(text => {
                let list = text.split(';');
                if (/;$/.test(text)) {
                    list.splice(list.length - 1);
                    return list.map(i => `${i};`);
                }
                return list.map((i, index) => {
                    if (index === list.length - 1) {
                        return i;
                    }
                    return `${i};`;
                });
            });
        },
        start(key) {
            this.domainInfo.forEach(i => { i.showIpt = false })
            this.domainInfo[key].showIpt = true;
            this.$nextTick(this.$refs.textarea[key].focus);
        },
        iptBlur(key, content) {
            this.domainInfo[key].showIpt = false;
            this.errorFlag = {};
        },
        validation(t, index, key) {
            let t1 = t.trim().replace(/;$/, '');
            if (key === 'socket') {
                if (!t1 || /^(wss:\/\/)[0-9a-zA-Z\.\-:]+$/.test(t1.trimEnd())) {
                    this.errorFlag[key] && this.errorFlag[key].delete(index);
                    return false;
                }
                this.errorFlag[key] = this.errorFlag[key] || new Set();
                this.errorFlag[key].add(index);
                return true;
            }
            else {
                if (!t1 || /^(https:\/\/)[0-9a-zA-Z\.\-:]+$/.test(t1.trimEnd())) {
                    this.errorFlag[key] && this.errorFlag[key].delete(index);
                    return false;
                }
                this.errorFlag[key] = this.errorFlag[key] || new Set();
                this.errorFlag[key].add(index);
                return true;
            }
            console.log('this.errorFlag', this.errorFlag)
        },
        cancel() {
            this.$emit('update:visible', false);
            this.$emit('refresh');
        },
        submit() {
            //console.log('this.errorFlag', this.errorFlag)
            if (JSON.stringify(this.errorFlag) !== "{}") {
                return false;
            }
            let params = this.domainInfo.reduce((pre, cur) => {
                pre[cur.key] = cur.content.split('\n').map(item => item.split(';')).flat(9).filter(i => i.trim());
                return pre;
            }, {});
            Object.keys(params).forEach(key => {
                params[key] = params[key].map(item => item.trim());
                params[key] = new Set(params[key]);
            });
            dao.shop.modifyServerDomain({
                appId: this.$route.params.appId,
                limitType: 1,
                ...params
            }).then(this.cancel).catch(this.$message.error);
        }
    },
    mounted() {
        this.domainInfo = Object.keys(this.value).reduce((pre, cur) => {
            if (cur !== 'businessList') {
                this.value[cur] = this.value[cur] || []
                pre.push({
                    content: JSON.parse(JSON.stringify(this.value[cur])).map(({ domain }) => domain).join(';\n'),
                    showIpt: false,
                    key: cur.replace(/List$/, '')
                })
            }
            return pre;
        }, []);
    }
};
</script>
<style lang="less" scoped>
.container {
    width: 100%;
    min-height: 54px;
    font-size: 14px;
    position: relative;
    .el-textarea, .textarea, .show {
        .el-textarea__inner {
            font-family: system-ui;
        }
    }
    .textarea {
        opacity: 0;
        &.show {
            opacity: 1;
        }
    }
    .temp {
        position: absolute;
        background: #fff;
        top: 0;
        left: 0;
        font-size: inherit;
        width: 100%;
        min-height: 54px;
        max-height: 327px;
        overflow: auto;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        padding: 5px 15px;
        line-height: 1.5;
        box-sizing: border-box;
        color: #606266;
        margin-bottom: 50px;
        word-wrap: break-word;
        word-break: normal;
        .line {
            letter-spacing: 1px;
            word-wrap: break-word;
            word-break: normal;
            //height: 21px;
            .error {
                color: #ff7b58;
            }
        }
        .empty {
            color: #ccc;
            user-select: none;
        }
    }
}
.container-domain {
    position: relative;
    font-size: 12px;
}
.domain-content {
    height: 500px;
    overflow-y: auto;
    padding-right: 22px;
}
.domain-content::-webkit-scrollbar-track {
    background-color: #f5f5f5;
}
.domain-content::-webkit-scrollbar {
    width: 4px;
    height: 10px;
    background-color: #f5f5f5;
}
.domain-content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgba(153, 153, 153, 0.5);
    height: 10px;
}
.domain-item {
    margin-bottom: 30px;
    padding-left: 145px;
    position: relative;
}
.domain-name {
    min-width: 120px;
    position: absolute;
    line-height: 22px;
    top: 6px;
    left: 0;
    text-align: right;
}
.list-item {
    position: relative;
    margin-bottom: 15px;

    el-input {
        border: 1px solid #e0e5ec;
        border-radius: 17px;
        box-sizing: border-box;
        padding: 0 30px 0 10px;
        color: #5c667e;
        font-size: 14px;
        outline: none;
        width: 620px;
        min-height: 40px;
        border-radius: 2px;
        padding: 3px;
    }
}

textarea::-webkit-input-placeholder {
    font-family: system-ui;
    color: #cccccc;
    font-size: 12px;
}
textarea:-moz-placeholder {
    font-family: system-ui;
    font-size: 12px;
    color: #cccccc;
}
textarea::-moz-placeholder {
    font-family: system-ui;
    color: #cccccc;
    font-size: 12px;
}
textarea:-ms-input-placeholder {
    font-size: 12px;
    color: #cccccc;
}
.btn {
    text-align: center;
    padding: 10px 0;
}
.btn-cancle {
    padding: 10px 34px;
    border: 1px solid #789aff;
    border-radius: 2px;
    width: 96px;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    color: #789aff;
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
}
.btn-ok {
    padding: 10px 13px;
    background: #789aff;
    border: 1px solid #789aff;
    border-radius: 2px;
    width: 96px;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
}
.error-info {
    color: #ff7b58;
    font-size: 12px;
    line-height: 14px;
    height: 14px;
    margin-top: 6px;
}
.error-info {
    color: #ff7b58;
    font-size: 12px;
    line-height: 14px;
    margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/developer/ServerConfig.vue